import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import cn from 'classnames'

import Navbar from '../containers/Navbar'
import TopNav from '../containers/orders/TopNav'
import OrdersList from '../containers/orders/List'
import OrdersSidebar from '../containers/orders/Sidebar'

import styles from './Orders.module.scss'
import Button from '../components/Button'
import { connect } from 'react-redux'
import { clearSelectedOrder } from '../actions/order'
import { onSafIsUploading } from '../actions/peripheral'
import { getSafIsUploading } from '../selectors/peripheral'

const Orders = ({ className, onUnmount, offlineCards, offlineOrders, safIsUploading, setSafIsUploading }) => {
  const classNames = cn(styles.orders, className)
  const history = useHistory()

  const onNewOrderClick = () => {
    history.push('/concession-order')
  }

  useEffect(() => {
    return () => {
      onUnmount()
    }
  })
  useEffect(() => {
    if (offlineCards === 0 && offlineOrders === 0 && safIsUploading) {
      setSafIsUploading(false)
    }
  }, [offlineCards, offlineOrders])

  return (
    <div className={classNames}>
      <Navbar className={styles.navbar} />
      <div className={styles.content}>
        <div className={styles.ordersContainer}>
          <TopNav className={styles.header} />
          <div className={styles.row}>
            <div className={styles.col1}>
              <OrdersList  />
            </div>
            <div className={styles.col2}>
              <OrdersSidebar  />
            </div>   
          </div>
              
        </div>
        <div className={styles.mobileBtnContainer}>
          <Button className={styles.mobileOrderBtn} onClick={onNewOrderClick} >
            New Order
          </Button>
        </div>    
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  offlineCards: state?.order?.offlineCardIds?.length ?? 0,
  offlineOrders: state?.order?.offlineLocalIds?.length ?? 0,
  safIsUploading: getSafIsUploading(state),
})

const mapDispatchToProps = (dispatch) => ({
  onUnmount: () => dispatch(clearSelectedOrder()),
  setSafIsUploading: (syncState) => dispatch(onSafIsUploading(syncState)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Orders)
